/**
 * WALL TAG round (Matt: "allow us to select an autogenerated wall tag and
 * hand-tweak its location if we want" + "give us a similar list [to roof
 * annotations] so we toggle on/off items"): the one stored exception to
 * "annotation is derived, never stored" for wall tags (annotate.js#layoutWallTags)
 * — mirrors roofPlanOverrides.js's shape and settings-map convention exactly,
 * with one simplification: a wall already has a real, stable element id (no
 * position-derived signature needed the way a roof RUN needs one).
 *
 * One settings-map key `wallTagOverrides`: { [elementId]: { hidden?: boolean,
 * offset?: [dx, dy] } }. `offset` is a HAND-DRAG adjustment in feet, added to
 * the derived default position at render — so if the wall moves/resizes, the
 * tag's base position moves with it and the manual nudge still applies
 * relatively, instead of pinning to a now-stale absolute point.
 *
 * An entry with neither field set is pruned from storage (mirrors
 * roofPlanOverrides.js's / references.js's empty-patch tidy-up).
 */
import { maps, transact } from '@aj/bim-kernel'

const SETTINGS_KEY = 'wallTagOverrides'

export function getWallTagOverrides(model) {
  const stored = maps(model).settings.get(SETTINGS_KEY)
  return stored && typeof stored === 'object' ? stored : {}
}

/** merge-patch one wall's override; a patch that empties the entry removes it */
export function setWallTagOverride(model, elementId, patch) {
  if (!elementId) return
  const stored = getWallTagOverrides(model)
  const next = { ...(stored[elementId] || {}), ...patch }
  const isEmpty = !next.hidden && !next.offset
  transact(model, () => {
    const merged = { ...stored }
    if (isEmpty) delete merged[elementId]
    else merged[elementId] = next
    maps(model).settings.set(SETTINGS_KEY, merged)
  })
}

export function setWallTagHidden(model, elementId, hidden) {
  setWallTagOverride(model, elementId, { hidden: !!hidden })
}

export function setWallTagOffset(model, elementId, offset) {
  setWallTagOverride(model, elementId, { offset: offset || null })
}

export function clearWallTagOverride(model, elementId) {
  setWallTagOverride(model, elementId, { hidden: false, offset: null })
}
